import RegisterBetaModal from "./RegisterBetaModalCancel";

export default RegisterBetaModal;
